<div class="fullscreen-loader" :class="{'mt': mt}" id="loader"><UiBaseLoader></UiBaseLoader></div>